<template>
    <div style="height:calc(100vh - 48px); overflow:auto; padding:5px;">
        <Loader ref="Loader"></Loader>

        <Transition name="fade">
            <div v-if="step == 1">
                <v-checkbox v-model="form.VisitedCustomer" label="Did you visit the customer?">
                </v-checkbox>
                <v-textarea v-model="form.CustomerComments" box label="Comments"></v-textarea>
                <p>Is this customer satisfied with SuburbanServ's services?</p>
                <v-layout row wrap>
                    <v-btn fab medium color="success" @click="SetCustomerRating(true)"
                        :class="{ 'active': form.CustomerRating == true }">
                        <v-icon>mood</v-icon>
                    </v-btn>
                    <v-layout justify-end>
                        <v-btn fab medium color="primary" @click="SetCustomerRating(false)"
                            :class="{ 'active': form.CustomerRating == false || !form.CustomerRating }">
                            <v-icon>mood_bad</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>

                <v-layout row wrap v-if="Images != null && Images.length > 0">
                    <v-carousel height="200">
                        <v-carousel-item v-for="(file, idx) in Images" :src="getImgSrc(file)" :key="idx">
                        </v-carousel-item>
                    </v-carousel>
                </v-layout>
                <v-layout row wrap v-else>
                    <div style="width:100%; height:150px; background-color: #fff; border: 1px solid gray; border-radius: 5px; display: flex; align-items: center; justify-content: center;"
                        @click="takePicture">

                        <div class="text-center">
                            <div>
                                No images found.
                            </div>
                            <div>
                                Click here to take images.
                            </div>
                        </div>
                    </div>
                </v-layout>


                <v-btn color="secondary" @click="takePicture" v-if="Images != null && Images.length > 0">Take more
                </v-btn>
                <v-btn color="secondary" @click="switchStep(2)" v-if="Inspections.length != 0"
                    :disabled="form.CustomerComments == null">Continue
                </v-btn>
                <v-btn color="secondary" @click="switchStep(2)" v-if="Inspections.length == 0"
                    :disabled="form.CustomerComments == null">End Visit
                </v-btn>
            </div>
        </Transition>

        <Transition name="fade">
            <v-flex xs12 v-if="step == 2 && Inspections.length != 0">
                <v-layout row wrap v-for="inspection in Inspections" :key="inspection.ID">
                    <v-layout justify-start>
                        <v-list>
                            <v-list-group prepend-icon="playlist_add_check" style="width: 100%">
                                <v-list-tile slot="activator" style="width: 90%">
                                    <v-list-tile-title>{{ inspection.AssessmentCategory.Name }}</v-list-tile-title>
                                </v-list-tile>
                                <!-- <v-list-tile v-for="assessment in inspection.Assessments" :key="assessment.ID"> -->
                                <v-layout v-for="assessment in inspection.Assessments" :key="assessment.ID">
                                    <v-checkbox v-model="assessment.Completed" :label="assessment.Name">
                                    </v-checkbox>
                                    <v-flex xs12 v-if="assessment.Completed == true">
                                        <v-layout>
                                            <v-textarea v-model="assessment.OpsComments" box label="Comments"></v-textarea>
                                        </v-layout>
                                        <div class="text-xs-center">
                                            <v-rating v-model="assessment.OpsRating" background-color="orange lighten-3"
                                                color="orange"></v-rating>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-list-group>
                        </v-list>
                    </v-layout>
                    <v-btn color="secondary" @click="StoreAssessments">End Visit</v-btn>
                </v-layout>
            </v-flex>
            <v-flex xs12 v-if="step == 2 && Inspections.length == 0">
                <span><b>No assessments have been set up for this customer</b></span>
            </v-flex>
        </Transition>

        <input type="file" ref="filePicker" style="display:none" accept="image/*" multiple @change="filePicked" />
    </div>
</template>

<script>
import JWT from "jsonwebtoken";
import moment from "moment";

export default {
    data() {
        return {
            step: 1,
            form: {
                OpsManagerTaskGroupID: 0,
                Type: 0,
                CustomerInspectionID: 0,
                VisitedCustomer: false,
                CustomerComments: null,
                OpsComments: null,
                DateTime: null,
                OpsRating: 0,
                CustomerRating: false,
                OpsManagerImages: []
            },
            CheckOutLong: null,
            CheckOutLat: null,
            Images: [],
            Inspections: [],
            AssessmentsToPost: [],
            CompletedInspections: [],
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            let self = this;
            let venueID = self.$route.params.venueID

            self
                .get(`CustomerAssessments/VenueCategoriesWithAssessments?venueID=${venueID}`)
                .then(r => {
                    r.data.forEach(inspection => {
                        self.Inspections.push({
                            AssessmentCategory: inspection.AssessmentCategory,
                            Assessments: inspection.Assessments
                        });
                    });

                    self.Inspections.forEach(item => {
                        item.Assessments.forEach(assessment => {
                            assessment.OpsComments = null;
                            assessment.OpsRating = 0;
                        })
                    })
                    console.log("[INSPECTIONS FOR THIS VENUE]", self.Inspections);
                });
        },
        SetCustomerRating(val) {
            this.form.CustomerRating = val;
        },
        switchStep(step) {
            let self = this;
            this.step = null;

            if (step == 2 && self.Inspections.length == 0) {
                self.StoreAssessments()
            } else {
                setTimeout(() => {
                    self.step = step;
                }, 350)
            }
        },
        StoreAssessments() {
            let self = this;
            var tmp = [];

            self.$refs.Loader.show();
            self.$refs.Loader.setText("Saving...");

            self.Inspections.forEach(item => {
                tmp.push(item.Assessments);
            })
            tmp.forEach(el => {
                el.forEach(item => {
                    self.AssessmentsToPost.push(item);
                })
            })

            this.submitTransaction();
        },
        checkOut() {
            let self = this;
            self.GetLocation();
            console.log("[CHECK-OUT LOCATION]", self.location);
            let venueID = self.$route.params.venueID

            self.$nextTick(() => {
                console.log("CHECK OUT FROM VENUE", venueID);
                self.$refs.Loader.show();
                self.$refs.Loader.setText("Checking out...");
                // GET OP CHECK IN FOR THIS VENUE & UPDATE IT
                self.get(`CheckInOut?venueID=${venueID}`).then(r => {
                    let Request = {
                        ID: r.data.ID,
                        CustomerVenueID: r.data.CustomerVenueID,
                        SystemUserID: r.data.SystemUserID,
                        CheckInDateTime: r.data.CheckInDateTime,
                        CheckInLat: r.data.CheckInLat,
                        CheckInLong: r.data.CheckInLong,
                        CheckOutDateTime: moment(Date.now()).format("YYYY-MM-DD hh:mm:ss"),
                        CheckOutLat: self.CheckOutLat,
                        CheckOutLong: self.CheckOutLong
                    };

                    // now update the checked-in item
                    self.put(`CheckInOut/${Request.ID}`, Request).then(response => {
                        console.log("[CHECKED-OUT]", r.data);
                        self.$refs.Loader.hide();

                        self.$router.push("/OpsManager/")
                    });
                });
            });
        },
        submitTransaction() {
            let self = this;

            self.$nextTick(() => {
                if (self.form.CustomerComments != null) {
                    let request = {
                        OpsManagerAssessmentAllocationID: self.$route.params.allocationID,
                        VisitedCustomer: self.form.VisitedCustomer,
                        Type: 1,
                        CustomerInspectionID: null,
                        CustomerComments: self.form.CustomerComments,
                        OpsComments: null,
                        OpsRating: null,
                        CustomerRating: self.form.CustomerRating,
                        Images: []
                    };

                    this.Images.forEach(img => {
                        var reader = new FileReader();
                        reader.onload = function () {
                            var bytes = Array.from(new Uint8Array(reader.result));

                            request.Images.push(bytes);
                        }

                        reader.readAsArrayBuffer(img);
                    });

                    self.post(`OpsManagerTX`, request).then(r => {
                        console.log("OPS TX TYPE 1 POSTED", r.data);

                        if (self.AssessmentsToPost.length == 0)
                            self.checkOut();
                    });
                }
            });
            console.log("[BEFORE POST INSPECTIONS]", self.AssessmentsToPost)
            self.$nextTick(() => {
                let requestList = [];
                self.AssessmentsToPost.forEach(completedInspection => {
                    console.log("completed inspection", completedInspection);
                    if (completedInspection.Completed == true) {
                        requestList.push({
                            OpsManagerAssessmentAllocationID: self.$route.params.allocationID,
                            VisitedCustomer: true,
                            Type: 2,
                            CustomerInspectionID: completedInspection.ID,
                            CustomerComments: null,
                            OpsComments: completedInspection.OpsComments,
                            OpsRating: completedInspection.OpsRating,
                            CustomerRating: null
                        });
                    } else if (completedInspection.Completed == false) {
                        requestList.push({
                            OpsManagerAssessmentAllocationID: self.$route.params.allocationID,
                            VisitedCustomer: false,
                            Type: 2,
                            CustomerInspectionID: completedInspection.ID,
                            CustomerComments: null,
                            OpsComments: completedInspection.OpsComments,
                            OpsRating: completedInspection.OpsRating,
                            CustomerRating: null
                        });
                    }
                    console.log("[REQUEST TO POST]", requestList);
                });
                self.post(`OpsManagerTX/Multiple`, requestList).then(r => {
                    console.log("[OPS TX INSPECTION POST]", r.data);
                    self.checkOut();
                    self.form.Type = 0;
                    self.form.CustomerInspectionID = 0;
                    self.form.VisitedCustomer = false;
                    self.form.CustomerComments = null;
                    self.form.OpsComments = null;
                    self.form.DateTime = null;
                    self.form.OpsRating = 0;
                    self.form.CustomerRating = false;
                    self.checkedInVenue = 0;
                    self.opsManagerTaskDialog1 = false;
                });
            });
        },
        GetLocation() {
            let self = this;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    self.showPosition,
                );
            } else {
                self.location = "Geolocation is not supported by this browser.";
            }
        },
        showPosition(position) {
            let self = this;
            self.location =
                "Latitude: " +
                position.coords.latitude +
                ", Longitude: " +
                position.coords.longitude;
            console.log("[GEO LOCATION POSITION]", position)

            var google_map_position = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            var google_maps_geocoder = new google.maps.Geocoder();
            google_maps_geocoder.geocode({
                'latLng': google_map_position
            },
                function (results, status) {
                    console.log("[GEOCODE RESULTS]", results);
                }
            );
            //self.showInMap(position);
            self.CheckOutLong = position.coords.longitude;
            self.CheckOutLat = position.coords.latitude;
            console.log("LOCATION", self.location);
        },
        takePicture() {
            let self = this;
            self.$refs.filePicker.click();
        },
        filePicked(evt) {
            let self = this;
            let files = evt.target.files;

            if (files != null && files.length > 0) {
                for (let index = 0; index < files.length; index++) {
                    const item = files[index];

                    self.Images.push(item)
                }
            }
        },
        getImgSrc(file) {
            return URL.createObjectURL(file);
        },
        uploadFiles() {

        }
    },
}
</script>

<style scoped>
.active {
    border-style: solid;
    border-color: rgb(0, 0, 0) !important;
}
</style>